



































































import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user';
import User from '@/entities/User';
import ModalService from '@/services/modal';

@Component
export default class Users extends Vue {
    userService = new UserService();

    modalService = new ModalService();

    user: User = null;

    mounted() {
        this.userService.get(this.$route.params.uuid)
            .then((user) => {
                this.user = user;
            });
    }

    askForConfirmation() {
        return this.modalService.showConfirmationModal(
            'Passport scan deletion',
            'Are you sure you want to delete this scan',
            () => this.deletePassport(),
            'Delete',
            'Cancel',
        );
    }

    deletePassport() {
        this.userService.deletePassport(this.$route.params.uuid)
            .then(() => {
                this.user.passportScan = null;
                this.user.passportScanVerso = null;
            });
    }

    askForBlockingConfirmation() {
        return this.modalService.showConfirmationModal(
            'You are banning user',
            'Are you sure you want to disable access for this user?',
            () => this.blockUser(),
            'Yes, block him',
            'Cancel',
        );
    }

    blockUser() {
        this.userService.block(this.$route.params.uuid)
            .then(() => {
                this.user.setBlocked();
            });
    }
}
